<template>
    <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 360 360" fill="none">
        <path d="M246.047 115.297C234.411 107.71 226.014 95.5723 223.394 81.4226C222.828 78.3655 222.517 75.2192 222.517 72H185.382L185.323 220.824C184.698 237.489 170.982 250.865 154.167 250.865C148.941 250.865 144.02 249.559 139.687 247.279C129.751 242.05 122.951 231.635 122.951 219.65C122.951 202.437 136.955 188.433 154.167 188.433C157.38 188.433 160.462 188.963 163.377 189.876V151.966C160.36 151.555 157.295 151.298 154.167 151.298C116.478 151.298 85.8164 181.961 85.8164 219.65C85.8164 242.774 97.3698 263.238 114.996 275.612C126.098 283.406 139.602 288 154.167 288C191.856 288 222.517 257.339 222.517 219.65V144.184C237.082 154.637 254.926 160.798 274.181 160.798V123.663C263.809 123.663 254.148 120.579 246.047 115.297Z" fill="white"/>
        </svg>
</div>
</template>
  
<script>

export default {
    name: "TiktokLogo",
};
</script>
<style lang="scss">
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";

.alterColor{
fill:$clr-saina-light-dark-main-bg
}

</style>